export default __webpack_public_path__ + "static/media/Brown-Light.02adb465.woff2";